import { BoardView } from './BoardBase';
import { ShelfBoardScaffold } from './ShelfBoardScaffold';
import { OliGroup } from './groupByOli';

interface Props {
	view?: BoardView;
	selectedGroup?: OliGroup | null;
	onSelect?: (g: OliGroup | null) => void;
}

/** JSA board — rack/shelf grid across the active job-staging areas. The `view`
 *  prop is accepted for interface parity but the shelf grid is always rendered
 *  (no list mode); selection is lifted to the tablet page's left sidebar. */
export const JSABoard = ({ selectedGroup, onSelect }: Props = {}) => (
	<ShelfBoardScaffold
		area="jsa"
		title="JSA"
		areaType="job_staging"
		storageKey="kt_default_jsa_area_id"
		selectedGroup={selectedGroup}
		onSelect={onSelect}
	/>
);
